import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFormatListNumbered$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatListNumbered extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1230a2f5f629f220706d3a5d0cd03fea5e18be64', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9e4a99de368ace0681dcc7f9a236a4ebcf33cbce', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '47ca71b491efd187fd4b41b07e9a0c29d6a52ba9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.256 7.07v-.384a.22.22 0 0 0-.206-.21h-.3v-2.04a.2.2 0 0 0-.2-.2h-.37a.7.7 0 0 0-.24.04l-.69.21a.2.2 0 0 0-.13.25l.08.32a.21.21 0 0 0 .27.15l.43-.14V6.48h-.454a.21.21 0 0 0-.2.21v.37a.21.21 0 0 0 .2.21h1.61a.2.2 0 0 0 .2-.2M7.5 5a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5h11A.5.5 0 0 0 19 6v-.5a.5.5 0 0 0-.5-.5zm0 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM7 16a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zm-2.844 1.8c.67 0 1.15-.37 1.15-.9a.75.75 0 0 0-.46-.71.7.7 0 0 0 .4-.66c0-.52-.43-.88-1.07-.88a1.063 1.063 0 0 0-1.13.84.16.16 0 0 0 .18.2h.46a.17.17 0 0 0 .16-.13c.05-.11.16-.177.28-.17.18 0 .29.1.29.25 0 .17-.11.25-.3.25h-.08a.21.21 0 0 0-.2.21v.2c0 .11.09.2.2.2h.09c.2 0 .31.1.31.26a.3.3 0 0 1-.58.1c-.04-.09-.09-.15-.18-.15h-.47a.155.155 0 0 0-.17.2c.067.553.566.95 1.12.89m1.13-5.78v.32a.21.21 0 0 1-.2.21h-1.85a.22.22 0 0 1-.21-.21v-.1a1.49 1.49 0 0 1 .83-1.19c.45-.28.54-.35.54-.52a.237.237 0 0 0-.25-.27.22.22 0 0 0-.24.18c-.03.1-.09.17-.19.17h-.5c-.13 0-.19-.08-.17-.19a1.033 1.033 0 0 1 1.14-.96.95.95 0 0 1 1.08.98c0 .5-.27.73-.79 1.06q-.232.145-.45.31h1.06a.21.21 0 0 1 .2.206z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-format-list-numbered", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-list-numbered"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-list-numbered":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatListNumbered$1);
            }
            break;
    } });
}

const CosmosIconFormatListNumbered = CosmosIconFormatListNumbered$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatListNumbered, defineCustomElement };
